import b64toBlob from 'b64-to-blob'

export const downloadFile = (fileName, fileData) => {
  // handling IE11 download since <a> tag doesn't handle download attribute
  if (navigator.msSaveOrOpenBlob) {
    // this function is deprecated on other navigators
    const blob = new Blob([atob(fileData)], {type: 'text/csv;charset=utf-8;'})
    navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    // on not deprecated navigators
    let linkSource = 'data:text/csv;charset=utf-8;base64,' + fileData
    let link = document.createElement('a')
    link.href = linkSource
    link.download = fileName
    let evt = document.createEvent('MouseEvents')
    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    link.dispatchEvent(evt)
  }
}

export const downloadFileWithDefinedHeaders = (that, fileName, fileData) => {
  if (
    that.$f7.device.os === 'android' ||
    that.$f7.device.os === 'ios'
  ) {
    that.$f7.hidePreloader()
    writeToFile(
      that,
      fileName,
      fileData,
      fileData.split(';')[0].replace(/^data:/, ''),
      false,
      function (filePath, fileType, fileName) {
        readFile(filePath, fileType, fileName)
      },
      function () {
        that.$f7.alert('', 'Error creating the file')
      }
    )
  } else {
    // handling IE11 download since <a> tag doesn't handle download attribute
    if (navigator.msSaveOrOpenBlob) {
      // this function is deprecated on other navigators
      const blob = new Blob([atob(fileData)])
      navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      // on not deprecated navigators
      let linkSource = fileData
      let link = document.createElement('a')
      link.href = linkSource
      link.download = fileName
      let evt = document.createEvent('MouseEvents')
      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      link.dispatchEvent(evt)
    }
  }
}

// each 16-bit unit occupies only one byte
export const toBinary = (string) => {
  const codeUnits = new Uint16Array(string.length)
  for (let i = 0; i < codeUnits.length; i++) {
    codeUnits[i] = string.charCodeAt(i)
  }
  return String.fromCharCode(...new Uint8Array(codeUnits.buffer))
}

export const fromBinary = (binary) => {
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return String.fromCharCode(...new Uint16Array(bytes.buffer))
}

// a string that contains characters occupying > 1 byte
// let encoded = btoa(toBinary('✓ à la mode')) // "EycgAOAAIABsAGEAIABtAG8AZABlAA=="
// our previous Base64-encoded string
// let decoded = fromBinary(atob(encoded)) // "✓ à la mode"

export const checkForWritePermissions = (that, sucess, error) => {
  /* eslint-disable no-undef */
  if (that.$f7.device.os === 'android') {
    cordova.plugins.diagnostic.requestRuntimePermission(
      function (status) {
        switch (status) {
          case cordova.plugins.diagnostic.permissionStatus.GRANTED:
            // console.log('Permission granted')
            sucess()
            break
          case cordova.plugins.diagnostic.permissionStatus.DENIED:
            // console.log('Permission denied')
            error()
            break
          case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
            console.log('Permission permanently denied')
            error()
            break
        }
      },
      function (error) {
        console.error('The following error occurred: ' + error)
      },
      cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
    )
  } else if (that.$f7.device.os === 'ios') {
    sucess()
  }
  /* eslint-enable no-undef */
}

export const readFile = (filePath, fileType, fileName) => {
  /* eslint-disable no-undef */
  // TODO : test fileType before trying to open and let the user know
  window.resolveLocalFileSystemURL(filePath, function (entry) {
    cordova.plugins.fileOpener2.open(
      entry.nativeURL.replace(/%20/g, ' '),
      fileType,
      {
        error: function (e) {
          // TODO : screen user stuff
        },
        success: function (s) {
          // TODO : screen user stuff
        },
      }
    )
  })
}

export const writeToFile = (that, fileName, data, fileType, readonly, success, error) => {
  /* eslint-disable no-undef */
  let directory = ''

  if (readonly) {
    if (that.$f7.device.os === 'android') {
      directory = cordova.file.externalDataDirectory
    } else if (that.$f7.device.os === 'ios') {
      directory = cordova.file.tempDirectory
    } else {
      directory = cordova.file.dataDirectory
    }
    saveFileToDirectory(
      fileName,
      data,
      fileType,
      directory,
      success,
      error
    )
  } else {
    // directory = cordova.file.externalRootDirectory
    if (that.$f7.device.os === 'android') {
      directory = cordova.file.externalRootDirectory
    } else if (that.$f7.device.os === 'ios') {
      // directory = cordova.file.dataDirectory
      directory = cordova.file.tempDirectory
    } else {
      directory = cordova.file.dataDirectory
    }
    try {
      checkForWritePermissions(that,
        function () {
          try {
            window.resolveLocalFileSystemURL(
              directory,
              function (directoryEntry) {
                directoryEntry.getDirectory(
                  'Download',
                  { create: true },
                  function (downloadDir, _data) {
                    saveFileToDirectory(
                      fileName,
                      data,
                      fileType,
                      downloadDir.nativeURL,
                      function (filePath, fileType) {
                        console.log('sucess saving file: ', filePath)
                      },
                      function (error, _data) {
                        console.error('error on saving file' + error.code)
                        alert('Unable to save file: ' + error.code)
                      }
                    )
                  },
                  function (error, _data) {
                    console.error(
                      'error on accessing download directory' + error.code
                    )
                    alert(
                      'Unable to get/create download directory: ' +
                        error.code
                    )
                  }
                )
              },
              (e, file) => {
                // error resolveLocalFileSystemURL
              }
            )
          } catch (error) {
            // get dir
            console.error(error)
          }
        },
        function () {
          alert(
            'App needs access to the phone\'s file storage in order to save files.'
          )
        }
      )
    } catch (error) {
      // get perms
      console.error(error)
    }
  }
  /* eslint-enable no-undef */
}

export const saveFileToDirectory = (fileName, data, fileType, directory, success, error) => {
  /* eslint-disable no-undef */
  let directoryEntryReference = null
  window.resolveLocalFileSystemURL(
    directory,
    function (directoryEntry) {
      directoryEntryReference = directoryEntry
      directoryEntry.getFile(
        fileName,
        { create: true, exclusive: true },
        function (fileEntry) {
          fileEntry.createWriter(
            function (fileWriter) {
              fileWriter.onwriteend = function (e) {
                success(e.target.localURL, fileType, fileName)
              }
              fileWriter.onerror = function (e) {
                error()
              }
              let blob = b64toBlob(
                data.replace(/^[^,]*,/, ''),
                fileType
              )
              fileWriter.write(blob)
            },
            (e, file) => {}
          )
        },
        (e, file) => {
          navigator.notification.confirm(
            'This file already exists do you want to override it ? (' +
              fileName +
              ')',
            function (index) {
              /* console.log(
                'Do you want to override the following file: ' +
                  fileName +
                  ' (' +
                  index +
                  ')'
              ) */
              switch (index) {
                case 1: // No
                  // console.log('No. Returning to idle state.')
                  break
                case 2: // Yes -> overrides  the file
                  // console.log('Yes. Overriding file.')
                  directoryEntryReference.getFile(
                    fileName,
                    { create: true, exclusive: false },
                    function (fileEntry) {
                      fileEntry.createWriter(
                        function (fileWriter) {
                          fileWriter.onwriteend = function (e) {
                            success(e.target.localURL, fileType, fileName)
                          }
                          fileWriter.onerror = function (e) {
                            error()
                          }
                          let blob = b64toBlob(
                            data.replace(/^[^,]*,/, ''),
                            fileType
                          )
                          fileWriter.write(blob)
                        },
                        (e, file) => {}
                      )
                    },
                    (e, file) => {}
                  )
                  break
              }
            },
            'Information',
            ['No', 'Yes']
          )
        }
      )
    },
    (e, file) => {
      // error resolveLocalFileSystemURL
    }
  )
  /* eslint-enable no-undef */
}
